import { apiRequest } from './apiClient';

export const listOturumlar = () =>
  apiRequest('/api/auth/oturumlar', { method: 'GET', skipCsrf: true });

export const revokeOturum = (sessionId) =>
  apiRequest(`/api/auth/oturumlar/${encodeURIComponent(sessionId)}`, {
    method: 'DELETE',
    skipCsrf: true,
  });

export const logoutAllDevices = () =>
  apiRequest('/api/auth/tum-cihazlardan-cikis', { method: 'POST', skipCsrf: true });
